/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from "react";

import Image from "react-bootstrap/Image";

import { APP_COLORS } from "../../../common/Constants";
import { faCheck, faQuestion } from "@fortawesome/pro-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components";

import CompanyIcon from "../../../common/assets/img/ToolbeltIcons_Artboard_19.png";
import {CompanyDetailText, IconInfo} from "../../../admin/companies/Company";

const ViewCompanyDetailHeader = (props) => {
    const { company } = props;

    return (
        <MainContainer>
            <IconInfo>
                <Image
                    className="company-icon"
                    src={company.logo || CompanyIcon}
                    alt="ToolBeltData Company Icon"
                    fluid
                    width={100}
                />
                <div style={{paddingTop: 15}}>
                    <CompanyDetailText
                        fontWeight={'bold'}
                        fontSize={25}
                    >
                        {company.name || ''}
                    </CompanyDetailText>
                    <CompanyDetailText
                        fontSize={12}
                    >
                        {company.url || ''}
                    </CompanyDetailText>
                </div>
            </IconInfo>

            <div style={{paddingTop: 10}}>
                <CompanyDetailText
                    fontSize={14}
                >
                    {company.phone || ''}
                    {company.url && (
                        <>
                            &nbsp;&nbsp;| &nbsp;&nbsp;
                            <a target='_blank' rel="noreferrer" href={company.url}>
                                <>{company.url}</>
                            </a>
                        </>
                    )}
                </CompanyDetailText>
                <CompanyDetailText fontSize={14} fontWeight={'bold'}>
                    {`${company.addressDeliveryLine1 || ''} 
                      ${company.addressDeliveryLine2  || ''} 
                      ${company.addressCity  || ''} 
                      ${company.addressRegion  || ''} 
                      ${company.addressPostalCode  || ''}`}
                </CompanyDetailText>
                <div>
                    <CompanyDetailText fontSize={14}>
                        {company.email || ''}
                        <span style={{ marginLeft: 10 }}>
                            {company.emailStatus && company.emailStatus === "Verified" && (
                                <FontAwesomeIcon
                                    color={APP_COLORS['green']}
                                    icon={faCheck}
                                />
                            )}
                            {company.emailStatus && company.emailStatus  !== "Verified" && (
                                <FontAwesomeIcon
                                    color={APP_COLORS['yellow']}
                                    icon={faQuestion}
                                />
                            )}
                        </span>
                    </CompanyDetailText>
                </div>
            </div>
        </MainContainer>
    )
}

export default ViewCompanyDetailHeader;

const MainContainer = styled.div`
    padding: 20px 20px 0 20px;
`;
